// menuData.js
const menuIdPos = [{ id: "home_id", pos: "22%" },
{ id: "beratungsfelder_id", pos: "16%" },
{ id: "unternehmen_id", pos: "7%" },
{ id: "kontakt_id", pos: "1%" },
]


const menuData = [
  {
    id: "home_id",
    title: "Home",
    link: "/", pos: "22%",
    submenu: []
  },
  {
    id: "beratungsfelder_id",
    title: "Beratungsfelder",
    link: "/beratungsfelder", pos: "16%",
    submenu: [
      {
        title: "Digitalisierungs- und Prozessberatung", link: "/beratungsfelder/fokusthema", id: "fokusthema",
        list: [{ id: "Immobilienverwaltung", to: "Risikomanagement", label: "Beratung", link: "/beratungsfelder/fokusthema/Immobilienverwaltung" },
        { id: "asset", to: "Compliance", label: "Digitalisierte Immobilienverwaltung", link: "/beratungsfelder/fokusthema/asset" },
        { id: "orga-check", to: "Compliance", label: "Orga Check-Konzept", link: "/beratungsfelder/fokusthema/orgacheck" },
        { id: "ebookdownloads", to: "Internes", label: "Beratungsprodukte", link: "/beratungsfelder/fokusthema/ebookdownloads" },
        ]
      },
      {
        title: "Unternehmenskäufe- und verkäufe / Nachfolgelösung", link: "/beratungsfelder/deal_advisory", id: "deal_advisory",
        list: [{ id: "sell_side", to: "Risikomanagement", label: "Sell Side", link: "/beratungsfelder/deal_advisory/sell_side" },
        { id: "buy_side", to: "Compliance", label: "Buy Side", link: "/beratungsfelder/deal_advisory/buy_side" },
        { id: "capital", to: "Internes", label: "Finanzierung / Kapitalbeschaffung", link: "/beratungsfelder/deal_advisory/capital" },
        { id: "market", to: "Governance", label: "Börsengang (IPO)", link: "/beratungsfelder/deal_advisory/market" },
        { id: "m_and_a", to: "Compliance", label: "Unternehmensnachfolge", link: "/beratungsfelder/deal_advisory/m_and_a" },
        { id: "profiling", to: "Internes", label: "Unternehmensbewertung", link: "/beratungsfelder/deal_advisory/profiling" },
        { id: "readiness", to: "Governance", label: "Exit- / IPO-Readiness", link: "/beratungsfelder/deal_advisory/readiness" },
        ]
      },
      {
        title: "Strategische Beratung", link: "/beratungsfelder/corporate_advisory", id: "corporate_advisory"

      },
      {
        title: "ESG", link: "/beratungsfelder/esg_advisory", id: "esg_advisory",
        list: [{ id: "ESG", to: "Risikomanagement", label: "ESG-Beratung", link: "/beratungsfelder/esg_advisory" },
        { id: "status_quo", to: "Risikomanagement", label: "ESG status quo", link: "/beratungsfelder/esg_advisory/status_quo" },
        { id: "reporting", to: "Compliance", label: "ESG Reporting & Communication", link: "/beratungsfelder/esg_advisory/reporting" },
        { id: "strategy", to: "Internes", label: "ESG Strategy", link: "/beratungsfelder/esg_advisory/strategy" },
        { id: "sustainability", to: "Governance", label: "Financing Sustainability", link: "/beratungsfelder/esg_advisory/sustainability" },
        { id: "opportunity", to: "Compliance", label: "ESG Opportunity (ESG Data & AI for Impact)", link: "/beratungsfelder/esg_advisory/opportunity" },
        { id: "kooperationspartner", to: "Internes", label: "Kooperationspartner", link: "/beratungsfelder/esg_advisory/kooperationspartner" },
        { id: "esg_ebook", to: "Governance", label: "ESG-Whitepaper", link: "/beratungsfelder/esg_advisory/esg_ebook" },
        ]
      }
      // Add more submenu items as needed
    ]
  },
  {
    id: "unternehmen_id",
    title: "Unternehmen",
    link: "/unternehmen", pos: "7%",
    submenu: [
      { title: "Management Team", link: "/unternehmen/managment_team", id: "managment_team" },
      { title: "Blog", link: "/unternehmen/blog", id: "blog" },
      { title: "Kooperationspartner", link: "/unternehmen/kooperationspartner", id: "kooperationspartner" },
      { title: "Karriere", link: "/unternehmen/karriere", id: "karriere" },
      { title: "Referenzen", link: "/unternehmen/referenzen", id: "referenzen" }
      // Add more submenu items as needed
    ]
  },
  {
    id: "kontakt_id",
    title: "Kontakt",
    link: "/kontakt", pos: "1%",
    submenu: []
  }
];

export default menuData;
